<div class="execution-detail-page">
  <header class="page-header">
    <div class="header-left">
      <button type="button" class="back-button" (click)="goBack()" [title]="'BUTTON.BACK' | translate">
        <fa-icon [icon]="icons.faArrowLeft"></fa-icon>
      </button>
      <div class="header-info">
        <h1 class="page-title">{{ title }}</h1>
        @if (execution) {
          <div class="execution-meta">
            <span><fa-icon [icon]="icons.faCalendar"></fa-icon> {{ execution.created_at | date:'dd/MM/yyyy' }}</span>
            <span><fa-icon [icon]="icons.faClock"></fa-icon> {{ execution.created_at | date:'HH:mm' }}</span>
            @if (execution.user) { <span>{{ execution.user }}</span> }
          </div>
        }
      </div>
    </div>
    @if (simulationType === 'processing' && processingFiles.length > 0) {
      <div class="file-selector">
        <label>{{ 'PROCESSINGS.RESULTS.FILE' | translate }}</label>
        <ng-select
          [items]="processingFiles"
          [(ngModel)]="selectedProcessingFile"
          (ngModelChange)="onProcessingFileChange($event)"
          [clearable]="false"
          [searchable]="processingFiles.length > 8"
          appendTo="body">
        </ng-select>
      </div>
    }
  </header>

  @if (isStillRunning) {
    <div class="running-banner">
      <fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon>
      <span>{{ 'PROCESSINGS.RESULTS.STILL_RUNNING' | translate }}</span>
    </div>
  }

  <main class="detail-content">
    @if (loading) {
      <div class="loading-state"><fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon></div>
    } @else if (execution) {
      @if (simulationType === 'retriever') {
        <app-retriever-result-view
          [result]="execution.result"
          [tokens]="execution.tokens || null">
        </app-retriever-result-view>
      } @else {
        <div class="comparison-grid">
          <section class="json-panel">
            <h2>{{ 'PROCESSINGS.RESULTS.INPUT_JSON' | translate }}</h2>
            <div class="editor-wrapper">
              @if (loadingProcessingInput) {
                <div class="loading-state"><fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon></div>
              } @else {
                <app-code-viewer [content]="processingInput" language="json"></app-code-viewer>
              }
            </div>
          </section>
          <section class="json-panel">
            <h2>{{ 'PROCESSINGS.RESULTS.OUTPUT_JSON' | translate }}</h2>
            <div class="editor-wrapper">
              <app-code-viewer [content]="processingOutput" language="json"></app-code-viewer>
            </div>
          </section>
        </div>
      }
    }
  </main>
</div>
